module.exports = __webpack_public_path__ + "static/media/sixteenth_viewpoint_bookstore4.9d42ff80.png";